import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=07bfa155&"
import script from "./complete.vue?vue&type=script&lang=js&"
export * from "./complete.vue?vue&type=script&lang=js&"
import style0 from "./complete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
